<template>
  <div
    class="NotificationBar"
    :class="level">
    <Icon :name="icon" />
    <span class="message">{{ message }}</span>
  </div>
</template>

<script>
export default {
  props: {
    level: {
      type: String,
      default: "standard",
    },
    message: {
      type: String,
      default: "You have been notified",
    },
  },

  computed: {
    icon() {
      return {
        standard: "info",
        info: "info",
        error: "error",
        warning: "error",
        success: "success",
      }[this.level];
    },
  },
};
</script>

<style lang="scss" scoped>
.NotificationBar {
  font-size: 1.142em;
  border-radius: 3px;
  padding: 0.5em;
  margin-bottom: 1em;
  color: white;
  flex: 1;
  background-color: var(--blue-purple);
  display: flex;
  align-items: center;

  .message {
    padding-left: 1em;
  }

  &.info {
    background-color: var(--midnight-blue);
  }

  &.error,
  &.warning {
    background-color: var(--pinkish-red);
  }

  &.success {
    background-color: var(--dark-seafoam);
  }
}
</style>
